<template>
  <div class="card">
    <h2>TEST</h2>
  </div>
  <div class="card">
    <div id="map"></div>
  </div>
</template>
<script>
  import "leaflet/dist/leaflet.css";
  import L from 'leaflet';
  import map from './map.json';
  export default {
    mounted() {
      const center_x = 117.3;
      const center_y = 172.8;
      const scale_x = 0.02072;
      const scale_y = 0.0205;

      const CUSTOM_CRS = L.extend({}, L.CRS.Simple, {
        projection: L.Projection.LonLat,
        scale: function(zoom) {

            return Math.pow(2, zoom);
        },
        zoom: function(sc) {

            return Math.log(sc) / 0.6931471805599453;
        },
        distance: function(pos1, pos2) {
              var x_difference = pos2.lng - pos1.lng;
              var y_difference = pos2.lat - pos1.lat;
              return Math.sqrt(x_difference * x_difference + y_difference * y_difference);
          },
        transformation: new L.Transformation(scale_x, center_x, -scale_y, center_y),
          infinite: true
      });
      var SateliteStyle = L.tileLayer('/mapStyles/styleSatelite/{z}/{x}/{y}.jpg', {minZoom: 0,maxZoom: 8,noWrap: true,continuousWorld: false,attribution: 'Online map GTA V',id: 'SateliteStyle map',}),
        AtlasStyle	= L.tileLayer('/mapStyles/styleAtlas/{z}/{x}/{y}.jpg', {minZoom: 0,maxZoom: 5,noWrap: true,continuousWorld: false,attribution: 'Online map GTA V',id: 'styleAtlas map',}),
        GridStyle	= L.tileLayer('/mapStyles/styleGrid/{z}/{x}/{y}.png', {minZoom: 0,maxZoom: 5,noWrap: true,continuousWorld: false,attribution: 'Online map GTA V',id: 'styleGrid map',});

      var ExampleGroup = L.layerGroup();

      var Icons = {
        "Example" :ExampleGroup,
      };

      var mymap = L.map('map', {
          crs: CUSTOM_CRS,
          minZoom: 1,
          maxZoom: 5,
          Zoom: 5,
          maxNativeZoom: 5,
          preferCanvas: true,
          layers: [SateliteStyle],
          center: [0, 0],
          zoom: 3,
      });

      // eslint-disable-next-line no-unused-vars
      var layersControl = L.control.layers({ "Satelite": SateliteStyle,"Atlas": AtlasStyle,"Grid":GridStyle}, Icons).addTo(mymap);
      
      for(var k in map) {
        var polyline = L.polyline(map[k], {color: 'red', weight: 5, opacity: 0}).bindPopup(k).addTo(mymap)

        polyline.on('mouseover', function() {
          this.setStyle({
            weight: 5,
            opacity: 0.5,
          });
          this.openPopup();
        });

        polyline.on('mouseout', function() {
          this.setStyle({
            weight: 5,
            opacity: 0
          });
          this.closePopup();
        });
      }
      

      var x = 1711.99;
      var y = 3604.24;

      var marker = L.marker([y, x], {color: 'yellow'}).bindPopup("i'm here")

      marker.addTo(mymap)
    }
  }  
</script>
<style scoped>
  .card {
    height: 100%;
    position: relative;
    background: #003D19;
    margin-right: 10px;
    margin-top: 10px;
    height: 97%;
    margin-bottom: auto;
    margin-top: auto;
    border: solid 2px #FFF;
    width: 100%;
  }
  .card:first-child {
    margin-left: 10px;
  }
  #map { 
    position:absolute;
    height: 100%; 
    width: 100%;
    top: 0;
    left: 0;
  }
  
</style>